/* eslint-disable no-shadow */
import { Middleware, Reducer } from 'redux';
import aiConversationReportApi from './aiConversationReportApi';
import { assigmentManagerApi } from './assignmentManager';
import AssistantApi from './assistantApi';
import AuthApi from './authApi';
import callsApi from './callsAPI';
import capiApi from './capiAPI';
import recordingApi from './recordingAPI';
// TODO FIX CYCLE DEPENDENCY
// eslint-disable-next-line import/no-cycle
import chatsApi from './chatsApi';
import { chatServicesApi } from './chatServices';
// eslint-disable-next-line import/no-cycle
import contactsApi from './contactsApi';
import knowledgeFilesApi from './knowledgeFilesApi';
import mercadoPagoApi from './mercadoPagoApi';
import { merchantApi } from './merchantApi';
import { partnerApi } from './partnerApi';
import partnerCustomUiApi from './partnerCustomUiApi';
import serviceMessagesApi from './serviceMessagesApi';
import { TagsApi } from './tagsApi';
import { tagsReportApi } from './tagsReport';
import { tagsReportExportApi } from './tagsReportExport';
import { TwoFactorAuthApi } from './twoFactorAuthApi';
import { FileStoreApi } from './uploadFiles';
import { UsersApi } from './userMeApi';
import webhookApi from './webhookApi';
import { whatsAppApi } from './whatsapp';
import { whatsAppTemplatesApi } from './whatsAppTemplatesApi';
import whatsappUsernameApi from './whatsappUsernameApi';
import mfaApi from './mfaApi';

const apis = reduxApis([
  AuthApi,
  tagsReportApi,
  tagsReportExportApi,
  chatServicesApi,
  assigmentManagerApi,
  whatsAppApi,
  TagsApi,
  partnerApi,
  partnerCustomUiApi,
  chatsApi,
  contactsApi,
  merchantApi,
  capiApi,
  AssistantApi,
  knowledgeFilesApi,
  UsersApi,
  FileStoreApi,
  TwoFactorAuthApi,
  callsApi,
  recordingApi,
  whatsAppTemplatesApi,
  mercadoPagoApi,
  webhookApi,
  whatsappUsernameApi,
  mfaApi,
  serviceMessagesApi,
  aiConversationReportApi,
]);

export default apis;

/**
 * this helper make a record with all middlewares and reducers for apis created with redux-toolkit createApi
 * @param apis List of apis
 * @returns
 */
function reduxApis<
  Api extends { middleware: Middleware; reducerPath: string; reducer: Reducer }
>(apis: Api[]) {
  type ApiRecord = {
    middleware: Middleware[];
    reducer: {
      [K in Api['reducerPath']]: Api['reducer'];
    };
  };

  return apis.reduce(
    (record, api) => {
      record.middleware.push(api.middleware);
      record.reducer[api.reducerPath as Api['reducerPath']] = api.reducer;
      return record;
    },
    { middleware: [], reducer: {} } as unknown as ApiRecord
  );
}
